module.exports = __webpack_public_path__ + "img/ich-grey.c2c4969d.png";